<template>
  <div>
    <div class="wh100 digit-container" layout="column center-center">
      <div class="label">{{label}}</div>
      <div ref="digit" class="digit">{{formatedValue}}</div>
    </div>
  </div>
</template>

<script>


  export default {
    name: "countdown-digit",
    props: ['label', 'value'],
    computed: {
      formatedValue: function () {

        if (this.$refs.digit) {
          const digit = this.$refs.digit;
          digit.style.textShadow = '0px 0px 2vw white';
          TweenLite.to(digit, 0.8, {
            textShadow:'0px 0px 0vw white'
          });
        }
        return this.value < 10 ? '0' + this.value : this.value;
      }
    }
  }
</script>

<style lang="scss" scoped>
  $max-width: 1200px;
  $min-width: 400px;

  .digit-container {
    margin-top: 3vw;
    @media screen and (min-width: $max-width) {
      margin-top: 40px;
    }
  }

  .label {
    font-weight: 400;
    font-size: 2vw;
    margin-bottom: -1.5vw;
    @media screen and (min-width: $max-width) {
      font-size: 24px;
      margin-bottom: -25px;
    }

    @media screen and (max-width: $min-width) {
      font-size: 8px;
    }
  }

  .digit {
    font-weight: 400;
    font-size: 11vw;
    letter-spacing: -0.4vw;
    @media screen and (min-width: $max-width) {
      font-size: 130px;
      letter-spacing: -5px;
    }

    @media screen and (max-width: 800px) {
      font-size: 10vw;
    }

    @media screen and (max-width: $min-width) {
      font-size: 44px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/blocks/CountdownDigit.vue